import React from 'react';
import {Form, InputNumber, FormInstance} from 'antd';
import _ from 'lodash';

type AmountProps = {
    autoFocus?: boolean;
    form?: FormInstance;
}

function handleBlur(ev: React.FocusEvent<HTMLInputElement>, form: FormInstance | undefined) {
    const value = ev.target.value;

    if (!/^\d+(\.\d+)?[+*/-]\d+(\.\d+)?$/.test(value)) {
        return value
    }

    // eslint-disable-next-line no-new-func
    const result = new Function(`return ${value}`)();
    form?.setFieldValue('amount', _.round(result, 2));
}

export function Amount({autoFocus = true, form}: AmountProps) {
    return (
        <Form.Item
            label={'Amount'}
            name={'amount'}
            rules={[{required: true, message: 'Please input the amount'}]}
        >
            <InputNumber
                id={'amount'}
                inputMode={'decimal'}
                changeOnBlur={false}
                onBlur={ev => handleBlur(ev, form)}
                autoFocus={autoFocus}
                controls={false}
                precision={2}
                min={0}
                step={0.01}
                addonAfter={'€'}
            />
        </Form.Item>
    )
}
